/*PROJECT NUMBER REQUESTER*/
Vue.component('projectnumberrequester',{
    template:'#projectnumberrequester-template',
    data:function(){
        return{
            client: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            recentProjectNumbers:[]
        };
    },
    created:function(){
        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });

            });
        },300);

        activeInstance = this;
        var id = $('#content_wrapper').attr('data-id');

        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/client/list/'+id).then(function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.client = response.data;
        }).bind(this);

    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);
            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        }
    },
    methods:{
        requestProjectNumber:function(){
            var validation = true;

            $('.error').removeClass('error');

            //CLIENT
            if($('#clientsearchfield').val().length < 2 ){
                validation = false;
                errorNotification('Az ügyfél cégneve túl rövid.');
                $('#clientsearchfield').addClass('error');
            }

            if($('#brand').val() == null ){
                validation = false;
                errorNotification('Nincs márka kiválasztva.');
                $('#brand').addClass('error');
            }


            if($('#sub_brand').val() == null ){
                validation = false;
                errorNotification('Nincs almárka kiválasztva.');
                $('#sub_brand').addClass('error');
            }


            if($('#project_name').val().length < 2 ){
                validation = false;
                errorNotification('Nem megfelelő a projekt neve.');
                $('#project_name').addClass('error');
            }

            if($('#date_start').val().length < 2 ){
                validation = false;
                errorNotification('Nincs kiválasztva a kezdő dátum.');
                $('#date_start').addClass('error');
            }

            if($('#date_end').val().length < 2 ){
                validation = false;
                errorNotification('Nincs kiválasztva a határidő.');
                $('#date_end').addClass('error');
            }

            //console.log( Date.parse($('#date_start').val()) );
            //console.log( Date.parse($('#date_end').val()) );
            if(Date.parse($('#date_start').val()) > Date.parse($('#date_end').val())){
                validation = false;
                errorNotification('A kezdeti dátum nem lehet későbbi mint a határidő.');
                $('#date_start').addClass('error');
                $('#date_end').addClass('error');
            }

            if(validation == true){

                bootbox.confirm('Minden adat helyes?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/createProjectNumber', {'client_id':activeInstance.activeClient.id, name:activeInstance.projectName, brand_id:activeInstance.activeBrandId,sub_brand_id:activeInstance.activeSubBrandId, start:activeInstance.projectStart,deadline:activeInstance.projectDeadLine}).then(function(response){
                            $('body').LoadingOverlay("hide");
                            if(response!=''){

                            }

                            successNotification('A projekt elkészült.');

                            //RESET FIELDS
                            activeInstance.projectName   = '';
                            activeInstance.activeBrandId = '';
                            activeInstance.activeSubBrandId = '';
                            activeInstance.projectStart = '';
                            activeInstance.projectDeadLine = '';
                            activeInstance.brands = [];
                            activeInstance.subBrands = [];
                            $('#clientsearchfield').val('');

                            activeInstance.recentProjectNumbers.push(response.data);

                        }).bind(this);

                    }
                });
            }
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(id){
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
            }).bind(this);

        },
        setActiveSubBrand:function(event){
            var subBrandId = $(event.target).val();
            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },
        checkPassword:function(){

            re = /^\w+$/;
            if(activeInstance.password != "" && activeInstance.password == activeInstance.password_verify) {
                if(activeInstance.password.length < 6) {
                    errorNotification("Hiba: A jelszónak legalább 6 karakter hosszúnak kell lennie!");
                    return false;
                }
                re = /[0-9]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy számnak szerepelnie kell!");
                    return false;
                }
                re = /[a-z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy kisbetűnek szerepelnie kell (a-z)!");
                    return false;
                }
                re = /[A-Z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy nagybetűnek szerepelnie kell (A-Z)!");
                    return false;
                }
            }
            else {
                if(activeInstance.password==""){
                    errorNotification("Hiba: A jelszó nincs kitöltve");
                    return false;
                }
                else{
                    errorNotification("Hiba: A jelszó nem egyezik a megerősítéssel.");
                    return false;
                }

            }
            return true;
        },
        togglePasswordField:function(){
            if(activeInstance.passwordFieldIsActive == true){
                activeInstance.passwordFieldIsActive = false;
            }
            else{
                activeInstance.passwordFieldIsActive = true;
            }
        },
        updateclientPassword:function(){
            var validated = activeInstance.checkPassword();
            if(validated == true){
                bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/client/update/password', {'client':activeInstance.client,'password':activeInstance.password}).then(function(response){
                            $('body').LoadingOverlay("hide");
                            successNotification('Jelszó sikeresen frissítve');
                        }).bind(this);
                    }
                });
            }
        },
        updateclientNameAndEmail:function(){
            bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/client/update/name_and_email', {'client':activeInstance.client,'password':activeInstance.password}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('Jelszó sikeresen frissítve');
                    }).bind(this);
                }
            });
        },
        toggleShippingRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        togglePersonalRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        toggleInvoiceRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        cancelPersonalEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelShippingEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelInvoiceEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        updatePersonalRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"personal"}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
            });
        },
        updateShippingRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"shipping"}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
            });
        },
        updateInvoiceRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"invoice"}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
                record.locked=true;
            });
        },
        //DESTROY
        deleteShippingRecord:function(record){

            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"shipping"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.client[0].shippingdata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });

        },
        deleteInvoiceRecord:function(record){
            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"invoice"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.client[0].invoicedata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });
        },
        save:function(){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/client/update',{client:activeInstance.client[0]}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
            });
        }
    }
});